import CaptchaInitializer from "../../../Scalesoft.Shared.FrontEnd/Scripts/Captcha/CaptchaInitializer";
import CaptchaTokenManager from "../../../Scalesoft.Shared.FrontEnd/Scripts/Captcha/CaptchaTokenManager";
import PasswordControl from "../PasswordControl";

jq(() => {

    const preregisteredRegistrationMigration = new PreregisteredRegistrationMigration(
        window.localization,
    );
    preregisteredRegistrationMigration.init();
});

class PreregisteredRegistrationMigration {
    private readonly localization: Localization;

    private readonly registerFormEl: JQuery<HTMLFormElement>;
    private readonly captchaInitializer: CaptchaInitializer;

    constructor(localization: Localization) {
        this.localization = localization;

        this.registerFormEl = jq("#user-from-eambulance-registration-form");

        const  captchaTokenManager = new CaptchaTokenManager();
        captchaTokenManager.init(jq);
        this.captchaInitializer = new CaptchaInitializer(captchaTokenManager);
    }

    public init(): void {
        if (PasswordControl !== undefined) {
            const passwordStrengthEstimator = new PasswordControl(this.registerFormEl);
            passwordStrengthEstimator.init();
        }

        this.captchaInitializer.prepareContainer(jq, this.registerFormEl);

        this.registerFormEl.on("submit", (event) => {
            event.preventDefault();
            const formIsValid = this.registerFormEl.valid();
            if (!formIsValid) { return false; }

            this.captchaInitializer.initForForm(jq, this.registerFormEl, "registrationFromEambulance");
        });
    }
}
